import { render, staticRenderFns } from "./sudi.vue?vue&type=template&id=942e06ea&scoped=true&"
import script from "./sudi.vue?vue&type=script&lang=js&"
export * from "./sudi.vue?vue&type=script&lang=js&"
import style0 from "./sudi.vue?vue&type=style&index=0&id=942e06ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942e06ea",
  null
  
)

export default component.exports